import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c4e1583"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto vat-tu-form-wrapper p-0" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 fv-row d-flex align-items-center rounded px-3 py-2 mb-4 bg-danger bg-opacity-10 border border-danger border-opacity-50 text-danger fs-6 fw-medium",
  role: "alert"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Dữ liệu đã được duyệt không thể chỉnh sửa bởi đơn vị ")
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "col-12 fv-row d-flex align-items-center rounded px-3 py-2 mb-4 bg-warning bg-opacity-10 border border-warning border-opacity-50 text-warning fs-6 fw-medium",
  role: "alert"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Dữ liệu đã được kiểm duyệt có thể chỉnh sửa và sử dụng toàn hệ thống mà không cần kiểm duyệt lại. Hãy kiểm tra kỹ thông tin trước khi lưu! ")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 2,
  class: "col-12 fv-row d-flex align-items-center rounded px-3 py-2 mb-4 bg-warning bg-opacity-10 border border-warning border-opacity-50 text-warning fs-6 fw-medium",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-inline-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "me-2" }, "⚠"),
  /*#__PURE__*/_createTextVNode(" Vật tư mới cần được phê duyệt để sử dụng làm dữ liệu cho toàn hệ thống ")
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_12 = {
  key: 0,
  class: "vat-tu-autocomplete-empty text-muted"
}
const _hoisted_13 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_14 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_15 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_16 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_17 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_18 = { class: "d-flex flex-column h-full justify-content-between align-items-center w-100" }
const _hoisted_19 = { class: "d-flex flex-column h-full justify-content-between align-items-center w-100" }
const _hoisted_20 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_21 = { class: "d-flex flex-column align-items-start w-100" }
const _hoisted_22 = { class: "mt-8 vat-tu-table-section" }

import { useStore } from "vuex";
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from "vue";
import type { ElAutocomplete, InputInstance } from "element-plus";
import debounce from "lodash/debounce";
import {
  setBreadcrumbLinks,
  setCurrentPageTitle,
} from "@/core/helpers/breadcrumb";
import { useRoute, useRouter } from "vue-router";
import { useCreatingForm } from "@/core/hooks/use-creating-form";
import {
  IDanhMucVatTuResponseBase,
  IVatTuResponseBase,
} from "@/core/interfaces/ApiResponses";
import { useButtonCustom } from "@/core/hooks/use-button-custom";
import { useLoading } from "@/core/hooks/use-loading";
import { resolveListPageForRoute } from "@/core/helpers/list-page-context";
import {
  isResponseError,
  lengthValidationRules,
  swalErrNotification,
  swalNotification,
} from "@/core/helpers/utils";
import { ICreateOrUpdateVatTuPayload } from "@/core/interfaces/Models";
import { VatTuService } from "@/core/services/VatTu.service";
import CurrencyInputCustom from "@/components/forms-elements/CurrencyInputCustom.vue";
import LabelCustom from "@/components/shared/label-custom/LabelCustom.vue";
import BaseLoading from "@/components/shared/BaseLoading.vue";
import PageContentBase from "@/layout/_shared/PageContentBase.vue";
import DivRow from "@/layout/_shared/DivRow.vue";
import DivCol from "@/layout/_shared/DivCol.vue";
import DanhMucVatTuService from "@/core/services/DanhMucVatTu.service";
import ButtonCustom from "@/components/shared/buttons/ButtonCustom.vue";
import useFormInput from "@/core/hooks/use-form-input";
import { usePagination } from "@/core/hooks/use-pagination";
import useCapDonVi from "@/core/hooks/use-cap-don-vi";
import DanhSachVatTuTable from "@/views/crafted/pages/vat-tu/danh-sach-vat-tu-table/DanhSachVatTuTable.vue";
import Pagination from "@/components/shared/pagination/Pagination.vue";

const MA_VAT_TU_PREVIEW_INTERVAL_MS = 3000;

export default /*#__PURE__*/_defineComponent({
  __name: 'FormV2',
  setup(__props) {

const route = useRoute();
const { params, name: routeName, query } = route;
const { formRef } = useCreatingForm();
const tenVatTuInputRef = ref<InputInstance | null>(null);
const danhMucVatTuAutocompleteRef = ref<InstanceType<typeof ElAutocomplete>>();

const isCreating = routeName === "tao-moi-vat-tu";
const idVatTu = params?.id ? Number(params.id) : null;

const { ButtonTypeColors, ButtonsType } = useButtonCustom();
const { isCompanyLevel } = useCapDonVi();

const { commit } = useStore();
const { focusFirstErrInputV2 } = useFormInput();
const { isLoading, setLoading } = useLoading();
const {
  currentPage,
  perPage,
  totalItems,
  loading: tableLoading,
} = usePagination();
currentPage.value = resolveListPageForRoute(query, { isCreate: isCreating });
const items = ref<IVatTuResponseBase[]>([]);

const getInitialForm = () => ({
  cong_ty_duyet: false,
  danh_muc_vat_tu_id: 0,
  ten_danh_muc: "",
  don_vi_tinh: "",
  dac_tinh: "",
  note: "",
  is_valid: false,
  ma_vat_tu: "",
  muc_du_tru_toi_thieu: 0,
  muc_du_tru_toi_da: 0,
  ten_vat_tu: "",
  thu_hoi: false,
});

const form = ref(getInitialForm());

const rules = ref({
  danh_muc_vat_tu_id: [
    {
      type: "number",
      message: "Phải chọn nhóm",
      trigger: "change",
      min: 1,
    },
  ],
  don_vi_tinh: [
    {
      type: "string",
      required: true,
      message: "Bắt buộc phải nhập",
      trigger: "change",
    },
  ],
  ten_vat_tu: [
    ...lengthValidationRules({
      name: "Tên vật tư",
    }),
  ],
  muc_du_tru_toi_thieu: [
    {
      type: "number",
      message: "Mức dự trữ tối thiểu phải lớn hơn hoặc bằng 0",
      trigger: "change",
      min: 0,
    },
    {
      type: "number",
      required: true,
      message: "Bắt buộc phải nhập",
      trigger: "change",
    },
  ],
  muc_du_tru_toi_da: [
    {
      type: "number",
      message: "Mức dự trữ tối đa phải lớn hơn hoặc bằng 0",
      trigger: "change",
      min: 0,
    },
    {
      type: "number",
      required: true,
      message: "Bắt buộc phải nhập",
      trigger: "change",
    },
  ],
  ...(!isCreating && {
    ma_vat_tu: [
      {
        type: "string",
        required: true,
        message: "Bắt buộc phải nhập",
        trigger: "change",
      },
    ],
  }),
});

let maVatTuPreviewIntervalId: ReturnType<typeof setInterval> | null = null;

const getPreviewMaVatTuDanhMucId = (): number | undefined => {
  const selectedDanhMucId = form.value.danh_muc_vat_tu_id;

  return selectedDanhMucId > 0 ? selectedDanhMucId : undefined;
};

const fetchPreviewMaVatTu = async () => {
  if (!isCreating) {
    return;
  }

  try {
    const {
      data: {
        data: { ma_vat_tu },
      },
    } = await VatTuService.generateMaVatTu(getPreviewMaVatTuDanhMucId());

    form.value.ma_vat_tu = ma_vat_tu;
  } catch {
    // Preview polling should not interrupt form usage.
  }
};

const startMaVatTuPreviewPolling = () => {
  if (!isCreating || maVatTuPreviewIntervalId) {
    return;
  }

  fetchPreviewMaVatTu();
  maVatTuPreviewIntervalId = setInterval(
    fetchPreviewMaVatTu,
    MA_VAT_TU_PREVIEW_INTERVAL_MS
  );
};

const stopMaVatTuPreviewPolling = () => {
  if (!maVatTuPreviewIntervalId) {
    return;
  }

  clearInterval(maVatTuPreviewIntervalId);
  maVatTuPreviewIntervalId = null;
};

const fetchVatTuItems = async () => {
  try {
    tableLoading.value = true;

    const {
      data: {
        data: { data, total },
      },
    } = await VatTuService.list({
      current_page: currentPage.value,
      per_page: perPage.value,
    });

    items.value = data;
    totalItems.value = total;
    tableLoading.value = false;
  } catch {
    await swalNotification(
      "Có lỗi xảy ra khi lấy thông tin danh sách vật tư",
      "error"
    );

    tableLoading.value = false;
  }
};

onMounted(async () => {
  await nextTick();

  setCurrentPageTitle(isCreating ? "Tạo mới vật tư" : "Chỉnh sửa vật tư");

  setBreadcrumbLinks([
    {
      text: "Vật tư",
      routeData: {
        name: "supplies",
      },
    },
    ...(isCreating === false
      ? [
          {
            text: "Chi tiết",
            routeData: {
              name: "supply-detail",
              params: {
                id: params.id as string,
              },
            },
          },
        ]
      : []),
    {
      text: isCreating ? "Tạo mới" : "Cập nhật",
    },
  ]);

  if (isCreating) {
    document.title = "Tạo mới - Vật tư - Đường sắt Hà Nội";
    startMaVatTuPreviewPolling();
  } else if (idVatTu && !isCreating) {
    setLoading(true);

    try {
      const {
        data: {
          data: {
            cong_ty_duyet,
            danh_muc_vat_tu,
            don_vi_tinh,
            dac_tinh,
            note,
            ten_vat_tu,
            is_valid,
            ma_vat_tu,
            muc_du_tru_toi_thieu,
            muc_du_tru_toi_da,
            thu_hoi,
          },
        },
      } = await VatTuService.fetchSupplyDetail(idVatTu);

      form.value.cong_ty_duyet = cong_ty_duyet;
      form.value.thu_hoi = thu_hoi;
      form.value.don_vi_tinh = don_vi_tinh;
      form.value.dac_tinh = dac_tinh ?? "";
      form.value.note = note ?? "";
      form.value.is_valid = is_valid === 1;
      form.value.ma_vat_tu = ma_vat_tu;
      form.value.muc_du_tru_toi_thieu = muc_du_tru_toi_thieu;
      form.value.muc_du_tru_toi_da = muc_du_tru_toi_da;
      form.value.ten_vat_tu = ten_vat_tu;

      if (danh_muc_vat_tu && danh_muc_vat_tu.length) {
        form.value.danh_muc_vat_tu_id = danh_muc_vat_tu[0].id;

        const {
          data: {
            data: { ten_danh_muc, ma_danh_muc },
          },
        } = await DanhMucVatTuService.get(danh_muc_vat_tu[0].id);

        form.value.ten_danh_muc = `${ten_danh_muc} (${ma_danh_muc})`;
      }

      document.title = `${ten_vat_tu} (${ma_vat_tu}) - Cập nhật - Vật tư - Đường sắt Hà Nội`;
    } catch (e) {
      await swalErrNotification(e, "Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  }

  await fetchVatTuItems();
  await focusDanhMucVatTuInput();
});

onUnmounted(() => {
  stopMaVatTuPreviewPolling();
});

const queryDanhMucVatTu = debounce(async function (s: string, fn) {
  if (!s.trim()) {
    return;
  }

  const {
    data: {
      data: { data },
    },
  } = await DanhMucVatTuService.searchByMaDanhMuc(s);

  if (!data || data.length === 0) {
    fn([
      {
        __empty: true,
        ten_danh_muc: "Không tìm thấy dữ liệu khả dụng",
        ma_danh_muc: "",
      },
    ]);
  } else {
    fn(data);
  }
});

const handleSelectDanhMucVatTu = ({
  ten_danh_muc,
  ma_danh_muc,
  id,
}: IDanhMucVatTuResponseBase) => {
  form.value.danh_muc_vat_tu_id = id;
  form.value.ten_danh_muc = `${ten_danh_muc} (${ma_danh_muc})`;
};

const focusDanhMucVatTuInput = async () => {
  if (isNhomVatTuDisabled.value) {
    return;
  }

  await nextTick();
  danhMucVatTuAutocompleteRef.value?.focus();
};

const focusTenVatTuInput = async () => {
  await nextTick();
  tenVatTuInputRef.value?.focus();
  tenVatTuInputRef.value?.input?.select();
};

const clear = async (shouldFocusTenVatTu = false, resetDanhMucVatTu = true) => {
  const { danh_muc_vat_tu_id, ten_danh_muc } = form.value;

  form.value = {
    ...getInitialForm(),
    ...(!resetDanhMucVatTu && {
      danh_muc_vat_tu_id,
      ten_danh_muc,
    }),
  };

  await nextTick();
  formRef.value?.clearValidate();

  if (shouldFocusTenVatTu) {
    await focusTenVatTuInput();
  }
};

const transformPayload = (): ICreateOrUpdateVatTuPayload => ({
  ...(!isCreating &&
    idVatTu && {
      id: Number(idVatTu),
    }),
  cong_ty_duyet: form.value.cong_ty_duyet ? 1 : 0,
  don_vi_tinh: form.value.don_vi_tinh,
  dac_tinh: form.value.dac_tinh.trim() || null,
  note: form.value.note.trim() || null,
  id_danh_muc: form.value.danh_muc_vat_tu_id,
  muc_du_tru_toi_thieu: form.value.muc_du_tru_toi_thieu,
  muc_du_tru_toi_da: form.value.muc_du_tru_toi_da,
  ten_vat_tu: form.value.ten_vat_tu,
  thu_hoi: form.value.thu_hoi ? 1 : 0,
});

const { replace } = useRouter();

const refreshFirstPage = async () => {
  if (currentPage.value !== 1) {
    currentPage.value = 1;

    return;
  }

  await fetchVatTuItems();
};

const handleSubmit = async (shouldContinue = false) => {
  formRef.value?.validate(async (isValid: boolean) => {
    if (isValid) {
      commit("ConfirmationDialogModule/setDialog", {
        title: "Xác nhận lưu vật tư",
        message: isCreating
          ? shouldContinue
            ? "Tạo mới vật tư với những thông tin này và tiếp tục tạo mới không?"
            : "Bạn có chắc chắn muốn tạo mới vật tư này?"
          : "Bạn có chắc chắn muốn cập nhật vật tư này?",
        confirmButtonText: isCreating ? "Tạo mới" : "Cập nhật",
        onConfirm: async () => {
          commit("ConfirmationDialogModule/closeDialog");
          await nextTick();
          setLoading(true);

          try {
            const {
              data: { data: res },
            } = await VatTuService.createOrUpdate(transformPayload());

            setLoading(false);

            if (isResponseError(res)) {
              await swalNotification(res.msg, "error");
              await focusTenVatTuInput();

              return;
            }

            await swalNotification(
              isCreating
                ? "Tạo vật tư thành công"
                : "Cập nhật vật tư thành công"
            );

            if (shouldContinue) {
              if (isCreating) {
                await clear(true, false);
              }

              await refreshFirstPage();

              return;
            }

            await replace({ name: "supplies" });
          } catch (e) {
            setLoading(false);

            await swalErrNotification(e, "Lưu vật tư thất bại");
            await focusTenVatTuInput();
          }
        },
      });
    } else {
      await focusFirstErrInputV2();

      return false;
    }
  });
};

watch(
  () => form.value.danh_muc_vat_tu_id,
  () => {
    if (isCreating) {
      fetchPreviewMaVatTu();
    }
  }
);

watch(
  () => currentPage.value,
  () => {
    fetchVatTuItems();
  }
);

watch(
  () => perPage.value,
  () => {
    if (currentPage.value === 1) {
      fetchVatTuItems();

      return;
    }

    currentPage.value = 1;
  }
);

const isEditingValidVatTu = computed(() => {
  return !isCreating && form.value.is_valid;
});

const isNhomVatTuDisabled = computed(() => {
  return isEditingValidVatTu.value && !isCompanyLevel.value;
});

return (_ctx: any,_cache: any) => {
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isLoading))
      ? (_openBlock(), _createBlock(BaseLoading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(PageContentBase, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            ref_key: "formRef",
            ref: formRef,
            rules: rules.value,
            model: form.value,
            onSubmit: _cache[19] || (_cache[19] = _withModifiers(() => handleSubmit(false), ["prevent"]))
          }, {
            default: _withCtx(() => [
              (form.value.is_valid && !_unref(isCompanyLevel))
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
                : (form.value.is_valid && _unref(isCompanyLevel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_7))
                  : (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10)),
              _createVNode(DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Nhóm v/tư:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "mb-0 w-full",
                          prop: "danh_muc_vat_tu_id"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_autocomplete, {
                              ref_key: "danhMucVatTuAutocompleteRef",
                              ref: danhMucVatTuAutocompleteRef,
                              modelValue: form.value.ten_danh_muc,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.value.ten_danh_muc) = $event)),
                              class: "w-full",
                              clearable: "",
                              disabled: isNhomVatTuDisabled.value,
                              "fetch-suggestions": _unref(queryDanhMucVatTu),
                              placeholder: "Nhập mã hoặc tên nhóm để tìm kiếm",
                              "trigger-on-focus": false,
                              "value-key": "ten_danh_muc",
                              onFocus: _cache[1] || (_cache[1] = ($event: any) => ($event.target.select())),
                              onSelect: handleSelectDanhMucVatTu,
                              onClear: _cache[2] || (_cache[2] = 
                      () => {
                        form.value.danh_muc_vat_tu_id = 0;
                        form.value.ten_danh_muc = '';
                      }
                    )
                            }, {
                              default: _withCtx(({ item }) => [
                                (item.__empty)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.ten_danh_muc), 1))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createElementVNode("span", null, [
                                        _createElementVNode("strong", null, _toDisplayString(item.ma_danh_muc) + " - ", 1)
                                      ]),
                                      _createElementVNode("span", null, _toDisplayString(item.ten_danh_muc), 1)
                                    ], 64))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "disabled", "fetch-suggestions"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 4
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tên vật tư:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "ten_vat_tu",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              ref_key: "tenVatTuInputRef",
                              ref: tenVatTuInputRef,
                              modelValue: form.value.ten_vat_tu,
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.ten_vat_tu) = $event)),
                              placeholder: "Nhập tên vật tư",
                              clearable: "",
                              readonly: isNhomVatTuDisabled.value,
                              disabled: isNhomVatTuDisabled.value,
                              onFocus: _cache[4] || (_cache[4] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue", "readonly", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 1
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("ĐVT")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "don_vi_tinh",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.value.don_vi_tinh,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.don_vi_tinh) = $event)),
                              placeholder: "ĐVT",
                              clearable: "",
                              disabled: isNhomVatTuDisabled.value,
                              readonly: isNhomVatTuDisabled.value,
                              onFocus: _cache[6] || (_cache[6] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue", "disabled", "readonly"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mã vật tư:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          class: "mb-0 w-full",
                          prop: "ma_vat_tu"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.value.ma_vat_tu,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.ma_vat_tu) = $event)),
                              clearable: "",
                              disabled: "",
                              readonly: "",
                              name: "ma_vat_tu"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mức dự trữ tối thiểu:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "muc_du_tru_toi_thieu",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CurrencyInputCustom, {
                              modelValue: form.value.muc_du_tru_toi_thieu,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.muc_du_tru_toi_thieu) = $event)),
                              name: "muc_du_tru_toi_thieu",
                              placeholder: "Mức dự trữ tối thiểu",
                              currency: "EUR"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(LabelCustom, { "is-required": "" }, {
                          default: _withCtx(() => [
                            _createTextVNode("Mức dự trữ tối đa:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "muc_du_tru_toi_da",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(CurrencyInputCustom, {
                              modelValue: form.value.muc_du_tru_toi_da,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.muc_du_tru_toi_da) = $event)),
                              name: "muc_du_tru_toi_da",
                              placeholder: "Mức dự trữ tối đa",
                              currency: "EUR"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(LabelCustom, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Tạo v/tư thu hồi:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "thu_hoi",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: form.value.thu_hoi,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.thu_hoi) = $event)),
                              disabled: isNhomVatTuDisabled.value,
                              name: "thu_hoi"
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 3
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(LabelCustom, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Cty quản lý:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "cong_ty_duyet",
                          class: "mb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_checkbox, {
                              modelValue: form.value.cong_ty_duyet,
                              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.cong_ty_duyet) = $event)),
                              disabled: isNhomVatTuDisabled.value,
                              name: "cong_ty_duyet"
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, { class: "mb-3 g-3" }, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(LabelCustom, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Đặc tính:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "dac_tinh",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.value.dac_tinh,
                              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.dac_tinh) = $event)),
                              type: "textarea",
                              autosize: { minRows: 2 },
                              resize: "none",
                              clearable: "",
                              placeholder: "Nhập đặc tính vật tư",
                              name: "dac_tinh",
                              onFocus: _cache[13] || (_cache[13] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(DivCol, {
                    "additional-class": "pb-4",
                    cols: 6
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(LabelCustom, null, {
                          default: _withCtx(() => [
                            _createTextVNode("Ghi chú:")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, {
                          prop: "note",
                          class: "mb-0 w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: form.value.note,
                              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.note) = $event)),
                              type: "textarea",
                              autosize: { minRows: 2 },
                              resize: "none",
                              clearable: "",
                              placeholder: "Nhập ghi chú",
                              name: "note",
                              onFocus: _cache[15] || (_cache[15] = ($event: any) => ($event.target.select()))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(DivRow, null, {
                default: _withCtx(() => [
                  _createVNode(DivCol, {
                    cols: 12,
                    "additional-class": "d-flex justify-content-center gap-x-2 my-4"
                  }, {
                    default: _withCtx(() => [
                      isCreating
                        ? (_openBlock(), _createBlock(ButtonCustom, {
                            key: 0,
                            "button-type": _unref(ButtonsType).ADD,
                            "color-type": _unref(ButtonTypeColors).PRIMARY,
                            "is-loading": _unref(isLoading),
                            onClick: _cache[16] || (_cache[16] = ($event: any) => (handleSubmit(true)))
                          }, {
                            "button-label": _withCtx(() => [
                              _createTextVNode("Lưu và tiếp tục")
                            ]),
                            _: 1
                          }, 8, ["button-type", "color-type", "is-loading"]))
                        : _createCommentVNode("", true),
                      _createVNode(ButtonCustom, {
                        "button-type": _unref(ButtonsType).SAVE,
                        "color-type": _unref(ButtonTypeColors).SUCCESS,
                        "is-loading": _unref(isLoading),
                        onClick: _cache[17] || (_cache[17] = () => handleSubmit(false))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("Lưu")
                        ]),
                        _: 1
                      }, 8, ["button-type", "color-type", "is-loading"]),
                      _createVNode(ButtonCustom, {
                        "button-type": _unref(ButtonsType).REFRESH,
                        "color-type": _unref(ButtonTypeColors).WARNING,
                        onClick: _cache[18] || (_cache[18] = () => clear(true, true))
                      }, {
                        "button-label": _withCtx(() => [
                          _createTextVNode("Nhập lại")
                        ]),
                        _: 1
                      }, 8, ["button-type", "color-type"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["rules", "model"]),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(DanhSachVatTuTable, {
              "cur-page": _unref(currentPage),
              "is-loading": _unref(tableLoading),
              items: items.value,
              "per-page": _unref(perPage),
              "selected-id": isCreating ? 0 : _unref(idVatTu) ?? 0,
              "show-approve-button": true,
              onDeleteVatTuSuccess: _cache[20] || (_cache[20] = ($event: any) => (fetchVatTuItems())),
              onOnApproveSuccess: _cache[21] || (_cache[21] = ($event: any) => (fetchVatTuItems())),
              onRefresh: _cache[22] || (_cache[22] = ($event: any) => (fetchVatTuItems()))
            }, null, 8, ["cur-page", "is-loading", "items", "per-page", "selected-id"]),
            (items.value.length > 0)
              ? (_openBlock(), _createBlock(Pagination, {
                  key: 0,
                  page: _unref(currentPage),
                  "page-size": _unref(perPage),
                  total: _unref(totalItems),
                  onChangePage: _cache[23] || (_cache[23] = (value) => (currentPage.value = value)),
                  onChangePageSize: _cache[24] || (_cache[24] = (value) => (perPage.value = value))
                }, null, 8, ["page", "page-size", "total"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    })
  ], 64))
}
}

})